import { PaginationType } from 'common';
import { TagType } from 'state';
import { AppRootStateType } from 'state/reducers';

export const selectTags = (state: AppRootStateType): TagType[] => state.tags.tags;

export const selectTagsSearch = (state: AppRootStateType): string | undefined =>
  state.tags.search;

export const selectTagsPagination = (state: AppRootStateType): PaginationType => ({
  page: state.tags.page,
  count: state.tags.count ?? 0,
});
